
export default function TransfertTelephone() {
    return (
        <main>
            <iframe src="https://form.jotform.com/252538612618056" frameBorder="0" style={{width: "100%", height: "100vh", marginTop: "6rem"}}></iframe>
        </main>
    );
}